<template>
  <div class="item-container">
    <div
      :id="`itemexpander-${item.jsonid}`"
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title">
        <i class="icon-travel_insurance_light glyph-lg pr-3" />
        <span>CANCELLATION COVER</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>Commencing on {{ item.startdate }}</h6>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div v-if="dropdown" class="item-dropdown">
      <div class="item-dropdown-main d-flex flex-column flex-lg-row">
        <ul>
          <li v-if="item.startdate" class="mobile-dropdown-item">
            <h4>Commencing on</h4>
            <p>{{ item.startdate }}</p>
          </li>
          <li v-if="item.insurancefor">
            <h4>Insurance for</h4>
            <p>{{ item.insurancefor }}</p>
          </li>
          <li v-if="item.status">
            <h4>Status</h4>
            <p>{{ item.status }}</p>
          </li>
        </ul>

      </div>
      <div v-if="item.fnotes[0]" class="extra-info-notes">
        Notes
        <ul>
          <li v-for="(note, index) in item.fnotes" :key="index">
            {{ note }}
          </li>
        </ul>
      </div>
      <p class="insurance-number">
        Your Trailfinders Travel Insurance policy number is
        {{ bookingNumber }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
    }
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: 'essentialInfoMenu/getMenu',
    }),
    bookingNumber() {
      return this.$store.getters['booking/getBookingNumber']
    },
  },
  mounted() {
    if (this.$refs['itemexpander-0']) {
      this.$refs['itemexpander-0'].click()
    }
    this.$root.$on('collapseall', () => {
      this.collapseAll()
    })
    this.$root.$on('expandall', () => {
      this.expandAll()
    })
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown
    },
    collapseAll() {
      this.dropdown = false
    },
    expandAll() {
      this.dropdown = true
    },
    openLink(link) {
      window.open(link)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles';
</style>
